import "./IconButtonDelete.scss"
import { useState, useRef, useEffect } from "react"
import { createPortal } from "react-dom"
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer"
import { t } from "i18next"
import IconDelete from "../icon/IconDelete"
import ClickSoak from "../layout/clicksoak/ClickSoak"
import Collapsible from "../layout/Collapsible"

export default function IconButtonDelete(props: IconButtonProps) {
    const [open, setOpen] = useState(false)
    const [coords, setCoords] = useState<{ top: number; left: number }>({ top: 0, left: 0 })

    const iconRef = useRef<HTMLDivElement>(null)
    const dropdownRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (open && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect()
            setCoords({
                top: rect.top + window.scrollY + 28,
                left: rect.left + window.scrollX + rect.width / 2 - 70,
            })
        }
    }, [open])

    useEffect(() => {
        const handleClickOutside = (e: Event) => {
            if (
                open &&
                iconRef.current &&
                !iconRef.current.contains(e.target as Node) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target as Node)
            ) {
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener("mousedown", handleClickOutside)
            document.addEventListener("scroll", handleClickOutside, true)
            window.addEventListener("resize", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
            document.removeEventListener("scroll", handleClickOutside, true)
            window.removeEventListener("resize", handleClickOutside)
        }
    }, [open])

    const handleDelete = () => {
        if (props.disabled) {
            return
        }

        props.onClick?.()
        setOpen(false)
    }

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        setOpen(!open)
    }

    return (
        <>
            <IconButtonContainer ref={iconRef} {...props} onClick={() => setOpen(!open)} tooltip={t("Delete")}>
                <IconDelete />
            </IconButtonContainer>

            {open &&
                createPortal(
                    <>
                        <ClickSoak />
                        <div

                            ref={dropdownRef}
                            className="confirm-dropdown"
                            style={{
                                top: coords.top,
                                left: coords.left,
                            }}
                            onClick={(e) => e.stopPropagation()}>
                            <button
                                className="confirm-btn cancel"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setOpen(false)
                                }}>
                                {t("Cancel")}
                            </button>
                            <button
                                className="confirm-btn delete"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleDelete()
                                }}>
                                {t("Delete")}
                            </button>
                        </div>
                    </>,
                    document.body
                )}
        </>
    )
}
